"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=account-proof.js.map